export default __webpack_public_path__ + "static/media/SFProDisplay-Bold.5b08afd6.woff";